import { render, staticRenderFns } from "./SmokingContent.vue?vue&type=template&id=51e86031&"
import script from "./SmokingContent.vue?vue&type=script&lang=js&"
export * from "./SmokingContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/htdocs/nc21docker/apps/health/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51e86031')) {
      api.createRecord('51e86031', component.options)
    } else {
      api.reload('51e86031', component.options)
    }
    module.hot.accept("./SmokingContent.vue?vue&type=template&id=51e86031&", function () {
      api.rerender('51e86031', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/smoking/SmokingContent.vue"
export default component.exports